// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-module__tag___609HL","active":"tag-module__active___fYI4R"};